
<div class="row" style="margin-left: -16px!important;margin-right: -16px!important;">
  <div class="col px-0">
    <section class="footer">
      <footer class="container">
        <div class="row pt-5 d-flex flex-column flex-sm-row">
          <div class="col-md-7 mb-3">
            <p><a data-testid="auto-app-webbtree-footer-a-1" class="navbar-brand z2" href="https://www.webbtree.com/"><img src="./assets/webbtree-white.png" alt="Webbtree"
                  title="Webbtree"></a>
            </p>
            <p class="text-white f-16">At Webbtree, we build products that solve day-to-day problems faced by recruiters globally.  Our products at Webbtree aim to reduce the time spent by recruiters on mundane jobs like copy pasting data, coordinating the same message via emails, sourcing & reaching out to passive candidates, enabling them to focus where it really matters.
            </p>
            <p class="f-14 font-weight-600 text-white mb-2">Follow us <span><a data-testid="auto-app-webbtree-footer-a-2"
                  href="https://www.facebook.com/webbtreeapp/" target="_blank" class="text-white"> <i
                    class="fab fa-facebook f-20 ml-3"></i></a><a data-testid="auto-app-webbtree-footer-a-3" href="https://www.linkedin.com/company/webbtree/"
                  target="_blank" class="text-white"> <i class="fab fa-linkedin f-20 ml-3"></i></a>
                <a data-testid="auto-app-webbtree-footer-a-4" href="https://twitter.com/Webbtreeapp/" target="_blank" class="text-white"> <i
                    class="fa-brands fa-square-x-twitter ml-3 f-20 mr-3 mb-2"></i></a>

                <a data-testid="auto-app-webbtree-footer-a-5" href="https://www.youtube.com/channel/UCByYZJoVS-6XxhU9EyzzgkQ" target="_blank" class="text-white"><i
                    class="fab fa-youtube f-20 mr-3 mb-2"></i></a>

                <a data-testid="auto-app-webbtree-footer-a-6" href="https://www.producthunt.com/posts/webbtree?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-webbtree"
                  target="_blank"><img
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=287555&theme=light"
                    alt="Webbtree - Get contact details and perform CRM for recruitment | Product Hunt" width=""
                    height="35" /></a></span>
            </p>
          </div>
          <div class="col-md-5 d-flex justify-content-sm-end flex-column flex-sm-row px-3 pt-2">
            <div class="mr-5">
              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-7" href="https://www.webbtree.com/webbtree-talent-source" target="_blank"
                  class="text-white">Webbtree Talent Source</a></p>
              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-8" href="https://www.webbtree.com/recroot-applicant-tracking-system-and-more.html"
                  class="text-white">Webbtree Recroot</a></p>
              <p class="f-14 font-weight-600 text-white position-relative"><a data-testid="auto-app-webbtree-footer-a-9" href="https://www.webbtree.com/chrome-extension.html"  target="_blank"
                  class="text-white">Chrome Extension <span class="freebox">Free</span> </a></p>
              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-10" href="https://www.webbtree.com/company-directory/industries" target="_blank"
                    class="text-white">Company Directory</a></p>
            </div>
            <div>

              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-11" href="https://www.webbtree.com/contact-us.html" class="text-white">Contact
                  us</a></p>
              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-12" href="https://www.webbtree.com/pricing.html" class="text-white">Pricing</a></p>
              <p class="f-14 font-weight-600 text-white position-relative"  style="width: 140px;"><a data-testid="auto-app-webbtree-footer-a-13" href="https://www.webbtree.com/career.html"
                target="_blank" class="text-white">Career <span class="freebox">We’re hiring</span>
              </a></p>
              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-14" href="https://webbtree.freshdesk.com/support/solutions"
                  target="_blank" class="text-white">Help</a></p>
              <p class="f-14 font-weight-600 text-white"><a data-testid="auto-app-webbtree-footer-a-15" href="https://www.webbtree.com/blog/" target="_blank"
                  class="text-white">Blog</a></p>
            </div>
          </div>
        </div>

      </footer>
      <hr class="text-white" style="border-bottom:1px solid #B4C3C8">
      <div class="container py-2">
        <div class="row d-flex flex-column flex-column-reverse flex-sm-row">
          <div class="col-md-6">
            <p class="f-14 font-weight-600 text-white">©{{currentyear}} Webbtree All rights reserved
            </p>
          </div>
          <div class="col d-flex justify-content-sm-end ">
            <p class="f-14 font-weight-600 text-white"><span><a data-testid="auto-app-webbtree-footer-a-16" href="https://www.webbtree.com/terms-and-conditions.html" class="text-white" target="_blank">Terms
                  & Conditions</a></span> <span class="ml-5"><a data-testid="auto-app-webbtree-footer-a-17" href="https://www.webbtree.com/privacy-policy.html" class="text-white" target="_blank">Privacy
                  policy</a></span></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
